import React from "react";
import { Dialog } from "@mui/material";
import { MessageWrap, MessageBox, ButtonBox } from "./styles";
import { Button } from "../Button";

interface Props {
  open: boolean;
  handleClose: () => void;
}

const Message = ({ open, handleClose }: Props) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      maxWidth={false}
    >
      <MessageWrap>
        <MessageBox>
          You don’t have permission to access that menu. <br />
          Please contact your administrator
        </MessageBox>
        <ButtonBox>
          <Button label="OK" type="text" onClick={handleClose} />
        </ButtonBox>
      </MessageWrap>
    </Dialog>
  );
};

export default Message;
